import axios from 'axios';
import content from 'src/common/content';
import headersRequest from 'src/common/helpers/headersRequest';

export const isReseller = () => {
  return process.env.BRAND_IDENTIFIER === 'boticario_reseller';
};

const resellerBusinessUnit = () => {
  return isReseller() ? 'boticario' : process.env.BRAND_IDENTIFIER;
};

const catalogService = {
  getCatalog: async (state: string = content.defaultState) => {
    return axios
      .get(`${process.env.API_BASE_URI}/magazine/`, {
        params: {
          business_unit: resellerBusinessUnit(),
          is_reseller: isReseller(),
          state,
        },
        headers: headersRequest
      })
      .then((res) => res.data)
      .catch((error) => error);
  },

  getProducts: async (skus: Array<string>, state = content.defaultState) => {
    const body = {
      page: 1,
      pageSize: 40,
      businessUnit: resellerBusinessUnit(),
      state: state,
      skus: skus,
    };
    return axios
      .post(`${process.env.API_BASE_URI}/product/`, body)
      .then((res) => res.data)
      .catch((error) => error);
  },

  getSearchResults: async (params: string) => {
    return axios
      .get(
        `${
          process.env.API_BASE_URI
        }/magazine/search/?is_reseller=${isReseller()}&business_unit=${resellerBusinessUnit()}${params}`,
      )
      .then((res) => res.data)
      .catch((error) => error);
  },

  getAllCycles: async () => {
    return axios
      .get(
        `${
          process.env.API_BASE_URI
        }/cycle/all-states?business_unit=${resellerBusinessUnit()}`,
        {
          headers: headersRequest
        }
      )
      .then((res) => res.data)
      .catch((error) => error);
  },
};

export default catalogService;
